import { Injectable } from '@angular/core';
import { PermissionConfig } from '../interface/inventory-configs';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissions: Record<string, any> = {};

  setPermissions(permissions: Record<string, any>) {
    if (permissions) {
      this.permissions = permissions;
    }
  }

  getPermission(group?: string) {
    if (!this.permissions || Object.keys(this.permissions).length === 0) return {};
    if(!group) return this.permissions;
    const permissions: any = this.permissions;
    return permissions[group];
  }

  checkPermission(permission?: PermissionConfig): boolean {
    if (!permission || !this.permissions || Object.keys(this.permissions).length === 0) return false;
    const permissions: any = this.permissions;
    return permissions[permission.permission_group]?.[permission.permission_key] ? false : true;
  }
}
